import { FC } from "react";
import { Outlet } from "react-router";

import { Footer, Header } from "./Navigation";

export const Layout: FC<React.PropsWithChildren<{}>> = () => {
  return (
    <div className="flex min-h-full flex-1 flex-col dark:bg-[#1B1C18]">
      <main className="flex h-full grow flex-col justify-between">
        <Header showSelectors={false} showLogo={true} />

        <div className="sm:py-8">
          <div className="mx-auto max-w-7xl px-0 sm:px-6 md:px-8">
            <Outlet />
          </div>
        </div>

        <Footer />
      </main>
    </div>
  );
};
